import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {PaletteColorsEnum} from '../../../../libs/shared/core/src/models/api/paletteModel';
import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisuallyHidden} from '../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';
import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface DropdownItemAccentIconProps {
  label: ReactNode;
  iconName: IconName;
  color?: PaletteColorsEnum;
  className?: string;
  shouldHideBackground?: boolean;
}

/*
 * Style.
 */

interface IconStyleProps {
  $color: PaletteColorsEnum;
  $shouldHideBackground?: boolean;
}
const StyledIconDiv = styled.div<IconStyleProps>`
  grid-area: left-icon;
  margin-right: 8px;

  ${(p) =>
    !p.$shouldHideBackground &&
    css`
      background-color: ${p.theme.palette[p.$color].shade20};
      border-radius: 100px;
    `}
`;

/*
 * Component.
 */

export const DropdownItemAccentIcon: FC<DropdownItemAccentIconProps> = ({
  label,
  iconName,
  color,
  className,
  shouldHideBackground,
}) => {
  const paletteColor = color || PaletteColorsEnum.BLUE;
  const theme = useUserTheme();
  return (
    <StyledIconDiv className={className} $color={paletteColor} $shouldHideBackground={shouldHideBackground}>
      <Icon name={iconName} color={theme.palette[paletteColor].shade40} />
      <VisuallyHidden>{label}</VisuallyHidden>
    </StyledIconDiv>
  );
};
